import { render, staticRenderFns } from "./FollowedList.vue?vue&type=template&id=4fbcb2db"
import script from "./FollowedList.vue?vue&type=script&lang=js"
export * from "./FollowedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports